
import ContactButton from "../ui/contact-button.vue";
export default {
  components: { ContactButton },
  data() {
    return {
      inView: false,
      modules: [],
      sortedModules: [],
      blogSlug: "blog",
    };
  },
  mounted() {
    if (this.$18n === "hr") {
      this.blogSlug = "objave";
    }
    this.getModules();
  },
  methods: {
    async getModules() {
      this.modules = await this.$getCategoriesInGroup("Helpdesk");
      const parsedArray = JSON.parse(JSON.stringify(this.modules));
      const sortedList = parsedArray.sort((a, b) =>
        a.title.localeCompare(b.title)
      );
      this.sortedModules = sortedList;
    },
  },
};
